module.exports = "/assets/1ed03112af64a1422c25c5dc9d07934c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/G8.png
// module id = 2521
// module chunks = 0